module.exports = __webpack_public_path__ + "img/spotify.db0f268d.png";